import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SelectWithLabel from '../selectWithLabel/selectWithLabel';

import './orderProductField.less';

class OrderProductField extends React.Component {
  initialState = {
    selectedProduct: '',
    quantity: 1,
  }

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  selectProduct = e => {
    this.setState({ selectedProduct: e.target.value });
  }

  setQuantity = e => {
    const number = parseInt(e.target.value, 10);
    this.setState({ quantity: !Number.isNaN(number) ? number : '' });
  }

  addProduct = () => {
    const { addProduct } = this.props;
    const { selectedProduct, quantity } = this.state;

    addProduct(selectedProduct, quantity || 1);
    this.setState(this.initialState);
  }

  getPriceLabel = product => {
    if (!product?.price) {
      return null;
    }

    return `(${product.price} zł)`;
  }

  render() {
    const {
      products,
    } = this.props;
    const { selectedProduct, quantity } = this.state;

    return (
      <div className="order-product-field-content">
        <FormControl variant="outlined" fullWidth>
          <SelectWithLabel value={selectedProduct} onChange={this.selectProduct} label="Wybierz produkt">
            {products.map(product => (
              <MenuItem key={product.id} value={product.id}>
                {product.name}
                {' '}
                {this.getPriceLabel(product)}
              </MenuItem>
            ))}
          </SelectWithLabel>
        </FormControl>

        <TextField
          label="Ilość"
          type="number"
          variant="outlined"
          fullWidth
          margin="normal"
          onChange={this.setQuantity}
          value={quantity}
          inputProps={{
            min: 1,
          }}
        />

        <div className="order-product-field-button-wrapper">
          <Button size="large" variant="contained" color="primary" onClick={this.addProduct} disabled={!selectedProduct || !quantity}>
            Dodaj
          </Button>
        </div>
      </div>
    );
  }
}

OrderProductField.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
  addProduct: PropTypes.func.isRequired,
};

export default OrderProductField;
